import React from 'react';
import cn from 'classnames';

import styles from './MLTranscription.module.css';

import AnnotationName from '../shared/AnnotationName';
import Instruction from '../shared/Instruction';
import Receipt from './Receipt';
import List from './List';

const MLTranscription = ({ animate }) => (
  <div className="h-full rounded-lg overflow-hidden flex flex-col">
    <AnnotationName icon="transcription" name="ML Transcription" />
    <Instruction instruction="Please transcribe this receipt." smallPadding />
    <div className="flex flex-grow items-center">
      <div className="w-full relative">
        <div className={cn(styles.receipt, { [`${styles.animate}`]: animate }, 'shadow-2xl')}>
          <Receipt animate={animate} />
        </div>
        <List animate={animate} />
      </div>
    </div>
  </div>
);

export default MLTranscription;
